import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5118f369"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "product-settlement"
};
const _hoisted_2 = {
  class: "filter-panel"
};
const _hoisted_3 = {
  class: "appListPopover-content"
};
const _hoisted_4 = {
  class: "appListPopover-content-title"
};
const _hoisted_5 = {
  class: "inf-label"
};
const _hoisted_6 = {
  class: "inf-value"
};
const _hoisted_7 = {
  class: "table-panel"
};
const _hoisted_8 = {
  class: "table-actions"
};
const _hoisted_9 = {
  key: 4
};
const _hoisted_10 = {
  class: "table-footer"
};
import { computed, onMounted, reactive, ref, watch } from 'vue';
import dayjs from 'dayjs';
import { message, Tag as ATag } from 'ant-design-vue';
import { saveAs } from 'file-saver';
import { getNode, detailFields, searchFields, getAppListInformation, copy, OK } from '@/common';
import { ProductSelect } from '@dbt/product-select';
import '@dbt/product-select/dist/style.css';
import { queryGoodsOption } from '@/api/goodsSetting';
import SvgIcon from '@/components/SvgIcon.vue';
import BillModal from '@/views/thirdPartyBill/components/BillModal.vue';
import SettlementAmount from './SettlementAmount.vue';
import DbtDatePicker from '@/components/DbtDatePicker.vue';
import * as api from '@/api/settlement';
import { buildColumns, cardType, formatAmount, formatRate, hasChannels, markets, normalizeRate, rowKey, toQuery } from './model';
import { useSettlement } from './useSettlement';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      filters,
      rows,
      products,
      channels,
      count,
      loading,
      exporting,
      fetchList,
      changeFilters,
      changeMarket,
      changePage,
      reset,
      exportFile
    } = useSettlement(api, {
      success: text => message.success(text),
      error: text => message.error(text),
      save: saveAs
    });
    const productSelectRef = ref();
    const productDetails = ref({});
    // 复用系统产品详情；可选范围始终由结算接口的市场、权限和代理筛选决定。
    onMounted(async () => {
      try {
        const response = await queryGoodsOption();
        if (response.code !== OK) throw new Error(response.msg || '产品详情加载失败');
        productDetails.value = Object.fromEntries((response.data || []).map(item => [String(item.dbtId), item.extData || {}]));
      } catch (cause) {
        message.error(cause instanceof Error ? cause.message : '产品详情加载失败');
      }
    });
    watch([products, productDetails, productSelectRef], () => {
      var _productSelectRef$val;
      (_productSelectRef$val = productSelectRef.value) === null || _productSelectRef$val === void 0 || _productSelectRef$val.initializeOptions(products.value.map(product => {
        const extData = {
          ...productDetails.value[product.dbtId],
          dbtId: product.dbtId
        };
        return {
          ...extData,
          value: product.dbtId,
          label: product.productName,
          filePath: extData.filePath || '-',
          extData
        };
      }));
    }, {
      flush: 'post'
    });
    const importVisible = ref(false);
    watch(() => filters.market, () => {
      importVisible.value = false;
    });
    const query = computed(() => toQuery(filters));
    const contextKey = computed(() => JSON.stringify(query.value));
    const monthRange = computed(() => filters.periods.split(',').map(value => dayjs(value)));
    const daySelection = reactive({
      startTime: '',
      endTime: '',
      recentDay: '',
      fromDayToDay: 0
    });
    // 公共组件使用YYYYMMDD；重置及市场切换时同步回显，选择完成后整体提交查询。
    watch(() => [filters.startDate, filters.endDate, filters.billType], () => {
      daySelection.startTime = dayjs(filters.startDate).format('YYYYMMDD');
      daySelection.endTime = dayjs(filters.endDate).format('YYYYMMDD');
      daySelection.recentDay = '';
      daySelection.fromDayToDay = 0;
    }, {
      immediate: true
    });
    const channelDimension = computed(() => {
      var _filters$dimensionLis;
      return ((_filters$dimensionLis = filters.dimensionList) === null || _filters$dimensionLis === void 0 ? void 0 : _filters$dimensionLis.includes('pay_chnl')) || false;
    });
    const columns = computed(() => buildColumns(filters.market, channelDimension.value, filters.billType));
    const tableWidth = computed(() => columns.value.reduce((total, column) => total + (column.children ? column.children.reduce((width, child) => width + (Number(child.width) || 130), 0) : Number(column.width) || 130), 0));
    const statOptions = [{
      value: 'day',
      label: '天'
    }, {
      value: 'month',
      label: '月'
    }, {
      value: 'total',
      label: '总计'
    }];
    const changeBillType = event => changeFilters({
      billType: event.target.value,
      statRange: 'day'
    });
    const changeMonths = dates => {
      if ((dates === null || dates === void 0 ? void 0 : dates.length) === 2) changeFilters({
        periods: dates.map(date => date.format('YYYY-MM')).join(',')
      });
    };
    const changeDates = () => {
      const dates = [dayjs(daySelection.startTime), dayjs(daySelection.endTime)];
      if (dates.every(date => date.isValid()) && !dates[0].isAfter(dates[1], 'day')) {
        changeFilters({
          startDate: dates[0].format('YYYY-MM-DD'),
          endDate: dates[1].format('YYYY-MM-DD')
        });
      }
    };
    const channelName = value => {
      var _channels$value$find;
      return ((_channels$value$find = channels.value.find(channel => channel.payChnl === value)) === null || _channels$value$find === void 0 ? void 0 : _channels$value$find.chnlName) || value || '-';
    };
    const rateClass = value => {
      var _normalizeRate;
      const rate = (_normalizeRate = normalizeRate(value)) !== null && _normalizeRate !== void 0 ? _normalizeRate : 0;
      return rate > 0 ? 'rate-positive' : rate < 0 ? 'rate-negative' : 'rate-zero';
    };
    return (_ctx, _cache) => {
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      const _component_a_radio_button = _resolveComponent("a-radio-button");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_range_picker = _resolveComponent("a-range-picker");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_createVNode(_component_a_tabs, {
        class: "market-tabs",
        "active-key": _unref(filters).market,
        onChange: _unref(changeMarket)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(markets), market => {
          return _openBlock(), _createBlock(_component_a_tab_pane, {
            key: market.key,
            tab: market.label
          }, null, 8, ["tab"]);
        }), 128))]),
        _: 1
      }, 8, ["active-key", "onChange"]), _createVNode(_component_a_form, {
        layout: "vertical",
        class: "filters"
      }, {
        default: _withCtx(() => [_unref(filters).market !== 'android' ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 0,
          label: "账单类型"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_radio_group, {
            value: _unref(filters).billType,
            "button-style": "solid",
            onChange: changeBillType
          }, {
            default: _withCtx(() => [_createVNode(_component_a_radio_button, {
              value: "day"
            }, {
              default: _withCtx(() => [_createTextVNode("日账单")]),
              _: 1
            }), _createVNode(_component_a_radio_button, {
              value: "month"
            }, {
              default: _withCtx(() => [_createTextVNode("月账单")]),
              _: 1
            })]),
            _: 1
          }, 8, ["value"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_a_form_item, {
          label: "结算时间"
        }, {
          default: _withCtx(() => [_unref(filters).billType === 'month' ? (_openBlock(), _createBlock(_component_a_range_picker, {
            key: 0,
            value: _unref(monthRange),
            picker: "month",
            format: "YYYY-MM",
            "allow-clear": false,
            "get-popup-container": _unref(getNode),
            onChange: changeMonths
          }, null, 8, ["value", "get-popup-container"])) : (_openBlock(), _createBlock(DbtDatePicker, {
            key: 1,
            startTime: daySelection.startTime,
            "onUpdate:startTime": _cache[0] || (_cache[0] = $event => daySelection.startTime = $event),
            endTime: daySelection.endTime,
            "onUpdate:endTime": _cache[1] || (_cache[1] = $event => daySelection.endTime = $event),
            recentDay: daySelection.recentDay,
            "onUpdate:recentDay": _cache[2] || (_cache[2] = $event => daySelection.recentDay = $event),
            fromDayToDay: daySelection.fromDayToDay,
            "onUpdate:fromDayToDay": _cache[3] || (_cache[3] = $event => daySelection.fromDayToDay = $event),
            dynamic: 0,
            "use-server-time": false,
            "show-use-server-time": false,
            "show-header": false,
            "show-dynamic": false,
            position: "bottomLeft",
            onChangeTime: changeDates
          }, null, 8, ["startTime", "endTime", "recentDay", "fromDayToDay"]))]),
          _: 1
        }), _unref(filters).billType === 'day' ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 1,
          label: "统计范围"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            class: "range-select",
            value: _unref(filters).statRange,
            options: statOptions,
            "get-popup-container": _unref(getNode),
            onChange: _cache[4] || (_cache[4] = value => _unref(changeFilters)({
              statRange: value
            }))
          }, null, 8, ["value", "get-popup-container"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_a_form_item, {
          label: "产品名称"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ProductSelect), {
            ref_key: "productSelectRef",
            ref: productSelectRef,
            "model-value": _unref(filters).dbtId || '',
            multiple: false,
            "show-select-all": false,
            "show-extra": true,
            "show-detail": true,
            "search-fields": _unref(searchFields),
            "detail-fields": _unref(detailFields),
            layout: "vertical",
            "description-field": "filePath",
            width: "230px",
            "popup-class-name": "vertical-product-select",
            placeholder: "请选择",
            "show-bottom-border": "",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = value => _unref(changeFilters)({
              dbtId: value || undefined
            }))
          }, {
            detail: _withCtx(({
              detail
            }) => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(SvgIcon, {
              iconClass: "informationIcon",
              class: "informationIcon"
            }), _createTextVNode(" " + _toDisplayString(detail.label), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAppListInformation)(detail.extData), child => {
              return _openBlock(), _createElementBlock("div", {
                key: child.label,
                class: "inf-line"
              }, [_createElementVNode("div", _hoisted_5, _toDisplayString(child.label) + "：", 1), _createElementVNode("div", _hoisted_6, _toDisplayString(child.value), 1), _createVNode(_component_a_tooltip, {
                title: "复制",
                placement: "top"
              }, {
                default: _withCtx(() => [_createVNode(SvgIcon, {
                  iconClass: "copy",
                  class: "dbt-copyIcon",
                  onClick: $event => _unref(copy)(child.value)
                }, null, 8, ["onClick"])]),
                _: 2
              }, 1024)]);
            }), 128))])]),
            _: 1
          }, 8, ["model-value", "search-fields", "detail-fields"])]),
          _: 1
        }), _unref(hasChannels)(_unref(filters).market) ? (_openBlock(), _createBlock(_component_a_form_item, {
          key: 2,
          label: "支付渠道"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            "data-test": "channel",
            class: "channel-select",
            value: _unref(filters).payChnl,
            options: _unref(channels),
            "field-names": {
              label: 'chnlName',
              value: 'payChnl'
            },
            placeholder: "请选择",
            "allow-clear": "",
            "get-popup-container": _unref(getNode),
            onChange: _cache[6] || (_cache[6] = value => _unref(changeFilters)({
              payChnl: value
            }))
          }, null, 8, ["value", "options", "get-popup-container"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_a_form_item, {
          class: "filter-actions"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_button, {
            class: "myGray",
            onClick: _unref(reset)
          }, {
            default: _withCtx(() => [_createTextVNode("重置")]),
            _: 1
          }, 8, ["onClick"]), _createVNode(_component_a_button, {
            type: "primary",
            loading: _unref(loading),
            disabled: _unref(loading),
            onClick: _unref(fetchList)
          }, {
            default: _withCtx(() => [_createTextVNode("查询")]),
            _: 1
          }, 8, ["loading", "disabled", "onClick"])]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("section", _hoisted_7, [_createVNode(_component_a_tabs, {
        class: "scope-tabs",
        "active-key": _unref(filters).scope,
        onChange: _cache[9] || (_cache[9] = value => _unref(changeFilters)({
          scope: value
        }))
      }, {
        rightExtra: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_unref(hasChannels)(_unref(filters).market) ? (_openBlock(), _createBlock(_component_a_checkbox, {
          key: 0,
          checked: _unref(channelDimension),
          onChange: _cache[7] || (_cache[7] = event => _unref(changeFilters)({
            dimensionList: event.target.checked ? ['pay_chnl'] : []
          }))
        }, {
          default: _withCtx(() => [_createTextVNode(" 支付渠道维度 ")]),
          _: 1
        }, 8, ["checked"])) : _createCommentVNode("", true), _unref(filters).market === 'gp' ? (_openBlock(), _createBlock(_component_a_button, {
          key: 1,
          "data-test": "import",
          class: "myGray",
          onClick: _cache[8] || (_cache[8] = $event => importVisible.value = true)
        }, {
          default: _withCtx(() => [_createTextVNode(" 导入账单 ")]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_a_button, {
          "data-test": "export",
          type: "primary",
          loading: _unref(exporting),
          disabled: _unref(exporting),
          onClick: _unref(exportFile)
        }, {
          default: _withCtx(() => [_createTextVNode(" 导出 ")]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"])])]),
        default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
          key: "all",
          tab: "全部"
        }), _createVNode(_component_a_tab_pane, {
          key: "agency",
          tab: "代理"
        }), _createVNode(_component_a_tab_pane, {
          key: "non-agency",
          tab: "非代理"
        })]),
        _: 1
      }, 8, ["active-key"]), _createVNode(_component_a_table, {
        class: "settlement-table",
        columns: _unref(columns),
        "data-source": _unref(rows),
        "row-key": _unref(rowKey),
        loading: _unref(loading),
        pagination: false,
        "table-layout": _unref(hasChannels)(_unref(filters).market) && _unref(channelDimension) ? 'fixed' : undefined,
        scroll: {
          x: _unref(hasChannels)(_unref(filters).market) && _unref(channelDimension) ? '100%' : _unref(tableWidth),
          y: '100%'
        },
        locale: {
          emptyText: '暂无数据'
        },
        size: "middle"
      }, {
        headerCell: _withCtx(({
          column
        }) => [_createTextVNode(_toDisplayString(column.title) + " ", 1), column.key === 'settlementIncome' || column.key === 'errorRate' ? (_openBlock(), _createBlock(_component_a_tooltip, {
          key: 0,
          title: column.key === 'errorRate' ? '结算收入与支付统计的差异比例' : '渠道实际结算收入',
          "get-popup-container": _unref(getNode)
        }, {
          default: _withCtx(() => [_createVNode(SvgIcon, {
            "icon-class": "questionMark",
            "class-name": "help-icon"
          })]),
          _: 2
        }, 1032, ["title", "get-popup-container"])) : _createCommentVNode("", true)]),
        bodyCell: _withCtx(({
          column,
          record
        }) => [column.key === 'productName' && record.calculationFailure ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode(_toDisplayString(record.productName || '-') + " ", 1), _createVNode(_component_a_tooltip, {
          title: record.calculationFailure
        }, {
          default: _withCtx(() => [_createVNode(_unref(ATag), {
            color: "error"
          }, {
            default: _withCtx(() => [_createTextVNode("重算失败（保留旧值）")]),
            _: 1
          })]),
          _: 2
        }, 1032, ["title"])], 64)) : ['period', 'productName', 'currency', 'payChnl'].includes(column.key) ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode(_toDisplayString(column.key === 'payChnl' ? channelName(record.payChnl) : record[column.key] || '-'), 1)], 64)) : _unref(filters).market === 'ios' && ['soldReportIncome', 'payStat', 'errorRate'].includes(column.key) ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_createTextVNode(" - ")], 64)) : column.key === 'errorRate' ? (_openBlock(), _createElementBlock("span", {
          key: 3,
          class: _normalizeClass(rateClass(record.errorRate))
        }, _toDisplayString(_unref(formatRate)(record.errorRate)), 3)) : ['payOrderCount', 'refundOrderCount'].includes(column.key) ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(formatAmount)(record[column.key], 0)), 1)) : (_openBlock(), _createBlock(SettlementAmount, {
          key: `${_unref(contextKey)}:${_unref(rowKey)(record)}:${column.key}`,
          value: record[column.key],
          "card-type": _unref(cardType)(_unref(filters).market, column.key, record),
          query: _unref(query),
          row: record
        }, null, 8, ["value", "card-type", "query", "row"]))]),
        _: 1
      }, 8, ["columns", "data-source", "row-key", "loading", "table-layout", "scroll"]), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", null, "共 " + _toDisplayString(_unref(count)) + " 条", 1), _unref(count) > 0 ? (_openBlock(), _createBlock(_component_a_pagination, {
        key: 0,
        current: _unref(filters).pageNum,
        "page-size": _unref(filters).pageSize,
        total: _unref(count),
        "show-size-changer": true,
        "page-size-options": ['20', '50', '100'],
        onChange: _unref(changePage)
      }, null, 8, ["current", "page-size", "total", "onChange"])) : _createCommentVNode("", true)])]), importVisible.value && _unref(filters).market === 'gp' ? (_openBlock(), _createBlock(BillModal, {
        key: 0,
        "model-visible": importVisible.value,
        "onUpdate:model-visible": _cache[10] || (_cache[10] = $event => importVisible.value = $event)
      }, null, 8, ["model-visible"])) : _createCommentVNode("", true)]);
    };
  }
});